import { useContext, useEffect } from "react";
import { Button } from "@material-ui/core";
import { withUbdAnalyticsStep } from "@aspirasi/react-data-analytics";
import { StoreContext } from "../../../store/context";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";

import { useThemeStyles } from "../../../styles/themes";
import "./ConsentInProgress.scss";
import clevertapWebview from "../../../utils/clevertap";
import { EVENT_NAME } from "../../../constants/clevertap";

const ConsentInProgress = () => {
  const classes = useThemeStyles();
  const { state, actions } = useContext(StoreContext);

  const content = {
    title: "We’ve received your information.",
    message: "You’ll receive an email to confirm the outcome of your financing switch to Boost Bank."
  };

  const redirectDashboard = (type) => {
    if (type === "new") {
      actions.getDashboardUrl().then((res) => {
        if (res.data?.redirectionUrl) {
          window.location.href = res.data?.redirectionUrl;
        }
      });
      return;
    }

    if (state.dashboardUrl) {
      window.location.href = state.dashboardUrl;
    } else {
      window.location.href = process.env.REACT_APP_BNPL_DASHBOARD_URL;
    }
  };

  useEffect(() => {
    clevertapWebview.pushEvent(EVENT_NAME.OUTCOME_BNPL_REG_SUCCESS, { SOURCE: "main" });
  }, []);

  return (
    state.prerequisites
    && (
      <>
        <Header />
        <div className="page page-consent-in-progress ">
          <div
            className={`${classes.content} ${classes.customScrollbar} content custom-scrollbar`}
            style={{ display: "flex", flexDirection: "column" }}
          >
            <div style={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
              <img
                className="banner"
                src="/images/in-progress.png"
                alt="in-progress"
              />
              <p className="in-progress-title">
                {content.title}
              </p>
              <p
                className="in-progress-sub-title"
                dangerouslySetInnerHTML={{
                  __html: content.message
                }}
              />
            </div>

            <div className="action-holder" style={{ display: "flex", flexDirection: "column", gap: "10px", }}>

              {state.isOnboardingUpdate && (
                <Button className={`${classes.btnContained} btn-next`} variant="contained" color="primary" onClick={() => redirectDashboard("new")}>
                  Done
                </Button>
              )}

            </div>

          </div>
          <Footer />
        </div>
      </>
    )
  );
};

export default withUbdAnalyticsStep(ConsentInProgress, {
  stepId: "ConsentInProgress",
  endJourneyOnStepStart: true,
});
